import { Box, Tab, Tabs, Typography } from "@mui/material";
import { TipoMovActions, TipoMovimentacao, TipoMovState } from "../tipomov.model";
import { TabPanel, a11yProps } from "../../../components/tab";
import { connect } from "react-redux";
import { mapDispatchToTipoMovProps, mapStateToTipoMovProps, TipoMovViewProps } from "../tipomov.controll";
import MovList from "../../movimentacoes/view/mov.list";
import { useEffect } from "react";

function TabsTipoMovs(props: TipoMovViewProps) {
    //a lista é carregada em tipomov.contrll funcao startDocTipoMovEffects  chamada em Rootview handleStart
    const { rows, row, tabValue } = props.tipoMovState
    const { setTabValue, set } = props.tipoMovActions
    

    useEffect(()=>{
        set(rows[tabValue])
        props.itemActions.read({
            fieldsFilter:[
                {fieldName:"ativo",mangoQuery:"$eq",fieldValue:true}
            ],
            indexName:"index_itens_ativo",
        })
    },[])

    const handleChangeTab = (event: React.SyntheticEvent, value: any) => {
        setTabValue(value);
        set(rows[value])
    }

    return (
        <Box sx={{ display:"flex",flex:1, flexDirection:"column",pt:1, width:"100%" }}>
            <Box sx={{display:"flex", flex:1, borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={tabValue} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile aria-label="Tipo de Movimentações">
                    {rows.map((value, idx) => (
                        <Tab key={idx} label={<Typography variant="subtitle1">{value.descricao}</Typography>} {...a11yProps(idx)} />
                    ))}

                </Tabs>
            </Box>
            {rows.map((value, idx) => (
                <TabPanel key={idx} value={tabValue} index={idx}  >
                    <MovList />
                </TabPanel>
            ))}
            
        </Box>
    )

}
export default connect(mapStateToTipoMovProps, mapDispatchToTipoMovProps)(TabsTipoMovs);